// extracted by mini-css-extract-plugin
module.exports = {"container":"_c8a6f3dd","expandIcon":"_2f531897"};